module.exports = __webpack_public_path__ + "img/off.672d3605.svg";